import {
  FETCH_APPOINTMENTDROPDOWN_REQUEST,
  FETCH_APPOINTMENTDROPDOWN_SUCCESS,
  FETCH_APPOINTMENTDROPDOWN_FAILURE,
} from "./AppointmentTypes";

const initialState = {
  loading: false,
  appointmentDropdown: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APPOINTMENTDROPDOWN_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_APPOINTMENTDROPDOWN_SUCCESS:
      return {
        loading: false,
        appointmentDropdown: action.payload,
        error: "",
      };
    case FETCH_APPOINTMENTDROPDOWN_FAILURE:
      return {
        loading: false,
        appointmentDropdown: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
